import React, { useRef, useState } from "react";
import "../Table/filter.scss";
import { TextField } from "@mui/material";
import filter from "../../assets/images/filter.svg";
import dropdown from "../../assets/images/dropdown.svg";

export default function CustomerFilter({ onApply, onClear }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  // Track applied filter
  const [appliedFilter, setAppliedFilter] = useState("");

  const searchFieldRef = useRef(null);

  const handleApply = () => {
    const trimmed = searchTerm.trim();

    setAppliedFilter(trimmed);

    if (typeof onApply === "function") {
      onApply({ searchTerm: trimmed });
    }

    setStatusMessage(
      trimmed
        ? `Search filter applied. Search: ${trimmed}.`
        : "No filter applied."
    );
  };

  const handleClear = () => {
    setSearchTerm("");
    setAppliedFilter("");

    if (typeof onClear === "function") onClear();

    setStatusMessage("Search filter cleared.");

    if (searchFieldRef.current) {
      searchFieldRef.current.focus();
    }
  };

  const isAnyLocalInput = !!searchTerm;
  const shouldShowClearButton = !!appliedFilter || isAnyLocalInput;

  return (
    <div className="global-filters">
      <button
        className="filtertn-forMobile"
        onClick={() => setShowFilters((prev) => !prev)}
        aria-expanded={showFilters}
        aria-controls="customerFilter"
      >
        <span>
          <img src={filter} alt="" />
          Filter
        </span>
        <span>
          <img
            src={dropdown}
            alt=""
            className={`drpIcon ${showFilters ? "toggleIcon" : ""}`}
          />
        </span>
      </button>

      <div
        className={`filterOptions ${showFilters ? "active" : "hidden"}`}
        id="customerFilter"
      >
        <div className="searchWrapper">
          <TextField
            id="search-customer"
            inputRef={searchFieldRef}
            placeholder="Search by Customer Name"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="innerFields serchBox"
            inputProps={{
              autoComplete: "off",
              "aria-label": "Search customer by customer Name",
            }}
          />
        </div>

        <div className="clearbtns">
          <button
            className={`filter-btn applyfilterbtn ${
              isAnyLocalInput ? "activeFilterBtn" : "inactiveFilterBtn"
            }`}
            disabled={!isAnyLocalInput}
            onClick={handleApply}
          >
            Apply Filter
          </button>

          {shouldShowClearButton && (
            <button
              className="filter-btn clearfilterbtn activeclearrBtn"
              onClick={handleClear}
            >
              Clear
            </button>
          )}
        </div>
      </div>

      <div
        className="sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {statusMessage}
      </div>
    </div>
  );
}
